import _ from 'lodash';
import PropTypes from 'prop-types';

import { Image, FadeInAnimation } from '../shared';
import useResponsive from '../../../utils/responsive';

const BusinessTravelSection = (props) => {
    const { title, paragraph, imgSrc, imgAlt, icons } = props;    
    const { isMobile, isTablet } = useResponsive();
    const smallDevice = isMobile || isTablet;

    const renderImageSection = () => {
        return <Image src={imgSrc} alt={imgAlt} isOldImage className="general-image" />;
    };

    const renderTextSection = () => {
        return (
            <FadeInAnimation>
                <div>
                    {!smallDevice && <h2 className='business-heading'>{title}</h2>}
                    <p className='business-paragraph'>{paragraph}</p>
                    {renderIcons()}
                </div>
            </FadeInAnimation>
        );
    };

    const renderIcons = () => {
        return icons.map((icon, index) => {
            const iconSrc = _.get(icon, 'icon_image.url');
            const iconTitle = _.get(icon, 'icon_title');
            const iconParagraph = _.get(icon, 'icon_paragraph');
            return (
                <FadeInAnimation key={index}>
                    <div className='business-icon-text-container'>
                        <div className='business-icon-container'>
                            <Image src={iconSrc} alt="" isOldImage />
                        </div>
                        <div>
                            <h5>{iconTitle}</h5>
                            <p className='business-icon-paragraph'>{iconParagraph}</p>
                        </div>
                    </div>
                </FadeInAnimation>
            );
        });
    };

    return (
        <div className='container-root container-root-maxWidthLg'>
            <div className='business-grid-container'>
                <div className='business-grid-lg-6 business-grid-item'>
                    {smallDevice && <h2 className='business-heading'>{title}</h2>}
                    {renderImageSection()}
                </div>
                <div className='business-grid-lg-5 business-grid-item'>
                    {renderTextSection()}
                </div>
            </div>
        </div>
    );
};

export default BusinessTravelSection;

BusinessTravelSection.propTypes = {
    title: PropTypes.string,
    paragraph: PropTypes.string,
    imgSrc: PropTypes.string,
    imgAlt: PropTypes.string,
    icons: PropTypes.array,
    isMobile: PropTypes.bool,
    isTablet: PropTypes.bool,
};
